<template>
	<Suspense>
		<CustomerHomePage v-if="userStore.role === 'customer'" />
	</Suspense>
</template>

<script setup lang="ts">
import { useUserStore } from "@/store/useUserStore";

const userStore = useUserStore();
</script>
